module.exports = __webpack_public_path__ + "static/media/s_v10_28.fe1f0347.mp3";